import { Injectable } from '@angular/core';
import { from, type Observable } from 'rxjs';
import type { AdminOfferCategoryListDto } from '../../../../backend/main';
import {
  deleteOfferCategoryAsync,
  findOfferCategoryAsync,
  listAdminOfferCategoriesAsync,
} from '../../../../backend/main';
import type { DtoListService, GetAllRequestParameters, ListPaginatedDTO } from '@pct/ng-core-dto';
import { UNKNOWN_ITEM } from '@pct/ng-core-dto';
import type { FilteredParams } from '../../../common/request/filtered-params';
import { mapSort } from '../../../common/request/map-sort';
import { convertPaginationParams } from '../../../common/utils/table/convert-pagination-params';
import type { OffersCategoryFilter } from './offers-category-filter';

@Injectable()
export class OffersCategoryDtoService implements DtoListService<
  AdminOfferCategoryListDto,
  FilteredParams<AdminOfferCategoryListDto, OffersCategoryFilter>
> {
  getAll(
    param: GetAllRequestParameters<FilteredParams<AdminOfferCategoryListDto, OffersCategoryFilter>>,
  ): Observable<ListPaginatedDTO<AdminOfferCategoryListDto>> {
    return from(
      listAdminOfferCategoriesAsync({
        body: {
          pagination: convertPaginationParams(param.pagination),

          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          sort: mapSort(param.parameters?.sort) as any,
          searchText: param.parameters?.filter?.searchText,
          status: param.parameters?.filter?.status,
          language: param.parameters?.filter?.language,
        },
      }).then(resp => resp.data),
    );
  }

  getById(id: string): Observable<Partial<AdminOfferCategoryListDto>> {
    return from(
      findOfferCategoryAsync({ path: { id } }).then(({ data }) => {
        const translation =
          data.translations.find(t => t.language === 'hu') ??
          data.translations.find(t => t.language === 'en');
        return {
          id: data.id,
          name: translation?.name ?? 'N/A',
        };
      }),
    );
  }

  getDtoId(dto: AdminOfferCategoryListDto): string;
  getDtoId(dto: AdminOfferCategoryListDto | null | undefined): string | null | undefined;
  getDtoId(dto: Partial<AdminOfferCategoryListDto> | null | undefined): string | null | undefined;
  getDtoId(
    dto: AdminOfferCategoryListDto | Partial<AdminOfferCategoryListDto> | null | undefined,
  ): string | null | undefined {
    return dto?.id ?? null;
  }

  toString(dto: AdminOfferCategoryListDto): string {
    return dto.name ?? UNKNOWN_ITEM;
  }

  delete(id: string): Observable<void> {
    return from(
      deleteOfferCategoryAsync({ path: { id } }).then(() => {
        // type cast to void
      }),
    );
  }
}
